import React from 'react';
import {MobileMenu} from '../HeaderMobileMenu/HeaderMobileMenu';
import {HeaderLogo} from '../HeaderLogoBlock/HeaderLogoBlock';
import {HeaderMenu} from '../HeaderMenu/HeaderMenu';
import {HeaderActions} from '../HeaderActions/HeaderActions';
import {HeaderSearch} from '../HeaderSearch/HeaderSearch';

export default function HeaderLayoutLeft({ links, item_count = '', settings, show_search_bar = false }) {
    // Check if the dedicated search block exists
    const hasSearchBlock = settings.blocks.some(block => block.type === "search_bar");

    return (
        <div className="w-full flex items-center lg:justify-between relative lg:py-[6px] lg:gap-6 xl:gap-8">
            <MobileMenu link_list={links} settings={settings}/>

            <div
                className="header-logo-and-menu flex items-center"
                style={{ gap: `${settings?.section?.menu_logo_spacing}px` }}
            >
                <HeaderLogo settings={settings} className={'lg:justify-center'} />
                <HeaderMenu link_list={links} settings={settings}/>
            </div>
          
            <div
                className="header-search-and-actions flex items-center flex-1 max-lg:justify-end"
                style={{ gap: `${settings?.section?.header_actions_spacing}px` }}
            >
                {hasSearchBlock && (
                    <HeaderSearch settings={settings} />
                )}
                
                <HeaderActions item_count={item_count} settings={settings}/>
            </div>
        </div>
    );
}
